import { Action } from '@ngrx/store';
import { Technology } from 'src/app/shared/types/technology.types';

export const TECHNOLOGIES_LOAD = '[TECHNOLOGY] Load technologies';
export const TECHNOLOGIES_LOAD_SUCCESS = '[TECHNOLOGY] Load technologies successful';
export const TECHNOLOGIES_LOAD_ERROR = '[TECHNOLOGY] Load technologies failed';

export class TechnologiesLoad implements Action {
  readonly type = TECHNOLOGIES_LOAD;
}

export class TechnologiesLoadSuccess implements Action {
  readonly type = TECHNOLOGIES_LOAD_SUCCESS;
  constructor(public payload: Technology[]) {}
}

export class TechnologiesLoadError implements Action {
  readonly type = TECHNOLOGIES_LOAD_ERROR;
}

export type Actions = TechnologiesLoad | TechnologiesLoadSuccess | TechnologiesLoadError;
